module.exports = __webpack_public_path__ + "img/android5bg1.1f46fd27.png";